import React from "react";
import useStore from "../../Store/Store"; // Adjust the import path as needed
import GenericDropdown from "../GenericDropDown";

export const propertyTypeOptions = [
  "Any",
  "Single family home",
  "Commercial",
  "Mobile home",
  "Multi family home",
  "Industrial",
  "Manufactured home",
  "Apartment",
  "Retail",
  "Other",
  "Condo",
  "Land",
  "Townhome",
  "Farm",
  "Parking",
];

export const propertyTypeValueMap = {
  "Single family home": "Single Family Dwelling",
  "Multi family home": "Multi-Family Dwelling",
  "Mobile home": "Mobile Home",
  "Manufactured home": "Manufactured Home",
  "Townhome": "Townhouse",
  "Parking": "Parking",
  // Add other mappings as needed
};

function PropertyType() {
  const { propertyType, setPropertyType, isQueryLoading } = useStore();

  return (
    <GenericDropdown
      options={propertyTypeOptions}
      label="Property type"
      setter={setPropertyType}
      selectedOptions={propertyType}
      valueMap={propertyTypeValueMap}
      isQueryLoading={isQueryLoading}
    />
  );
}

export default PropertyType;
